import cn from 'classnames';

interface BestSellerWrapperProps extends React.DetailedHTMLProps<
  React.LabelHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> {
  isMobile?: boolean;
  bestSellerLength: number;
  message?: React.ReactNode;
}

/** Groups bestseller products in the collection grid. */
const BestSellerWrapper: React.FC<React.PropsWithChildren<BestSellerWrapperProps>> = ({
  children,
  isMobile = false,
  className,
  bestSellerLength,
  message,
  ...otherProps
}) => {
  const formattedMessage = message ? (
    <span className="font-mindset text-2xl font-normal tracking-wide">{message}</span>
  ) : null;

  return (
    <div
      className={cn(
        `lg:col-span-${bestSellerLength}`,
        'relative right-1/2 left-1/2 -mx-[50vw] flex w-screen flex-col lg:static lg:mx-0 lg:w-auto'
      )}
    >
      <div
        className={cn('bg-badge-bestseller w-full py-2', 'lg:rounded-lg lg:px-2', className)}
        {...otherProps}
      >
        <div className="px-4 lg:container lg:px-0!">
          {message && (
            <span
              id="bestSellerWrapperMessage"
              className="text-primary-main mb-4 inline-block px-2"
              data-test="bestseller-wrapper-message"
            >
              {formattedMessage}
            </span>
          )}
          <div
            className={cn(
              'grid grow gap-3 lg:gap-5',
              isMobile ? 'grid-cols-1' : `grid-cols-${bestSellerLength}`
            )}
            data-test="bestseller-wrapper-grid"
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestSellerWrapper;
